// @ts-nocheck
import { PUBLIC_BASE_URL } from '$env/static/public';
import { getAuthToken } from '#/lib/auth';

const base = PUBLIC_BASE_URL;
const authHeaders = () => ({ 'auth-token': getAuthToken() || '' });

export async function getEnabledList(type) {
	const res = await fetch(`${base}/feedback-letter/enabled-list?task=${type}`, {
		headers: authHeaders()
	});
	if (!res.ok) throw new Error('과업 목록 조회 실패');
	return res.json();
}

export async function setDeadline(taskId, deadlineAt) {
	const res = await fetch(`${base}/feedback-letter/deadline-at/${taskId}`, {
		method: 'PUT',
		headers: { 'Content-Type': 'application/json', ...authHeaders() },
		body: JSON.stringify({ deadlineAt })
	});
	if (!res.ok) throw new Error('마감일 설정 실패');
	return res.json();
}

export async function downloadLinkExcel(taskId) {
	const res = await fetch(`${base}/feedback-letter/create-link-excel/${taskId}`, {
		headers: authHeaders()
	});
	if (!res.ok) throw new Error('엑셀 파일 다운로드에 실패했습니다.');
	return res.blob();
}

export async function deleteTask(taskId) {
	const res = await fetch(`${base}/feedback-letter/${taskId}`, {
		method: 'DELETE',
		headers: authHeaders()
	});
	if (!res.ok) throw new Error('삭제 실패');
	return res.json();
}

export async function downloadKNOCExcel(settingId) {
	const res = await fetch(`${base}/feedback-letter/create-knoc-excel/${settingId}`, {
		headers: authHeaders()
	});
	if (!res.ok) throw new Error('석유공사 엑셀 파일 다운로드에 실패했습니다.');
	return res;
}

export async function getLetterList(taskId, params = {}) {
	const filtered = Object.fromEntries(
		Object.entries(params).filter(([, v]) => v !== undefined && v !== '' && v !== false)
	);
	const query = new URLSearchParams(filtered).toString();
	const res = await fetch(
		`${base}/feedback-letter/enabled-letter-list/${taskId}${query ? `?${query}` : ''}`,
		{ headers: authHeaders() }
	);
	if (!res.ok) throw new Error('레터 목록 조회 실패');
	return res.json();
}

export async function getVersionList(taskId, applicant, id) {
	const res = await fetch(`${base}/feedback-letter/version/${taskId}/${applicant}/${id}`, {
		headers: authHeaders()
	});
	if (!res.ok) throw new Error('버전 목록 조회 실패');
	return res.json();
}

export async function setDownloadStatus(letterId, downloadStatus) {
	const res = await fetch(`${base}/feedback-letter/download-status/${letterId}`, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', ...authHeaders() },
		body: JSON.stringify({ downloadStatus })
	});
	if (!res.ok) throw new Error(`${res.status}`);
	return res.json();
}

export async function getLetterDetail(taskId, letterId) {
	const res = await fetch(`${base}/feedback-letter/detail/${taskId}/${letterId}`, {
		headers: authHeaders()
	});
	if (!res.ok) throw new Error('레터 상세 조회 실패');
	return res.json();
}

export async function editLetterContent(versionId, body) {
	const res = await fetch(`${base}/feedback-letter/edit-content/${versionId}`, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', ...authHeaders() },
		body: JSON.stringify(body)
	});
	if (!res.ok) throw new Error('수정 실패');
	return res.json();
}

export async function downloadSingle(taskId, downloadId) {
	const res = await fetch(`${base}/feedback-letter/download/${taskId}/${downloadId}`, {
		headers: authHeaders()
	});
	if (!res.ok) throw new Error(`${res.status}`);
	return res;
}

export async function downloadAll(taskId) {
	const res = await fetch(`${base}/feedback-letter/download/${taskId}/all`, {
		headers: authHeaders()
	});
	if (!res.ok) throw new Error(`${res.status}`);
	return res;
}

export async function downloadByDept(taskId, dept) {
	const res = await fetch(
		`${base}/feedback-letter/download/${taskId}/${encodeURIComponent(dept)}`,
		{ headers: authHeaders() }
	);
	if (!res.ok) throw new Error(`${res.status}`);
	return res;
}
